import type { ToolResult } from "@/types/tools";

const LOWER = "abcdefghijklmnopqrstuvwxyz";
const UPPER = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const DIGITS = "0123456789";
const SYMBOLS = "!@#$%^&*()-_=+[]{};:,.?";

export type PasswordOptions = {
  length: number;
  includeUppercase: boolean;
  includeLowercase: boolean;
  includeDigits: boolean;
  includeSymbols: boolean;
};

export function generatePassword(options: PasswordOptions): ToolResult<string> {
  const groups = [
    options.includeLowercase ? LOWER : "",
    options.includeUppercase ? UPPER : "",
    options.includeDigits ? DIGITS : "",
    options.includeSymbols ? SYMBOLS : "",
  ].filter(Boolean);

  if (!groups.length) {
    return { ok: false, error: "Choose at least one character set." };
  }

  if (options.length < groups.length) {
    return { ok: false, error: "Length must be at least the number of selected sets." };
  }

  const pool = groups.join("");
  const passwordChars: string[] = groups.map((group) => pickRandom(group));

  for (let index = passwordChars.length; index < options.length; index += 1) {
    passwordChars.push(pickRandom(pool));
  }

  shuffle(passwordChars);

  return { ok: true, value: passwordChars.join("") };
}

function pickRandom(text: string) {
  return text[Math.floor(Math.random() * text.length)] ?? "";
}

function shuffle(items: string[]) {
  for (let index = items.length - 1; index > 0; index -= 1) {
    const swapIndex = Math.floor(Math.random() * (index + 1));
    [items[index], items[swapIndex]] = [items[swapIndex], items[index]];
  }
}
